export default "<div class=\"unit-groups\">\n  <unit-groups-settings></unit-groups-settings>\n</div>\n";